import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { db } from "../firebase";
import { collection, addDoc, query, where, getDocs, Timestamp } from "firebase/firestore";
import "../styles/Turnos.css";
import servicios from "../data/serviciosData";

/**
 * Datos para la seña — los que pegaste en canvas
 */
const DATOS_PAGO = {
  titular: "Sandra Noemi Olivares",
  alias: "shanna.369",
  cvu: "3840200500000000009878",
  banco: "Uala Bank S.A.U",
  senia: 5000,
};
const formatearFecha = (date) => {
  return date.toISOString().split("T")[0]; // YYYY-MM-DD
};

function obtenerDuracionServicio(servicio, selectedOption, servicios) {
  if (!servicio) return 1;

  const servObj = servicios.find(s => s.nombre === servicio);
  if (!servObj) return 1;

  // Servicios sin opciones
  if (!servObj.opciones) return servObj.duracion || 1;

  // Servicios con opciones
  const opt = servObj.opciones.find(
    o => `${servicio} — ${o.tipo}` === selectedOption
  );

  return opt ? opt.duracion : 1;
}

const Turnos = () => {
  // estado
  const [selectedDate, setSelectedDate] = useState(null);
  const [dias, setDias] = useState([]);
  const [horariosOcupados, setHorariosOcupados] = useState([]);
  const [bloqueados, setBloqueados] = useState([]);
  const [selectedTime, setSelectedTime] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [nombre, setNombre] = useState("");
  const [telefono, setTelefono] = useState("");
  const [servicio, setServicio] = useState("");
  const [apellido, setApellido] = useState("");
 

const duracionServicio = React.useMemo(() => {
  return obtenerDuracionServicio(servicio, selectedOption, servicios);
}, [servicio, selectedOption]);

  const diasValidos = [2, 4, 5, 6]; // martes=2, jueves=4, viernes=5, sábado=6
  const horariosBase = ["09:00","10:00","11:00","12:00","13:00","15:00","16:00","17:00","18:00"];
  const SENIA = DATOS_PAGO.senia;
// Generar próximos 14 días hábiles DESDE HOY
useEffect(() => {
  const generarDias = () => {
    const resultado = [];
    let offset = 0; // 👈 arrancamos HOY

    while (resultado.length < 14) {
      const d = new Date();
      d.setDate(d.getDate() + offset);
      offset++;

      if (diasValidos.includes(d.getDay())) {
        resultado.push(new Date(d));
      }

      if (offset > 60) break;
    }

    return resultado;
  };

  

    const proximos = generarDias();
    setDias(proximos);
    // inicializar selectedDate al primer día disponible
    if (proximos.length > 0) setSelectedDate(proximos[0]);
  }, []); // solo al montar

  // Obtener turnos ocupados desde Firestore para el día seleccionado
  useEffect(() => {
    if (!selectedDate) return;

    // cada vez que cambie la fecha limpiar selección previa (evita arrastre)
    setSelectedTime("");
    setSelectedOption("");

    const fetchHorarios = async () => {
      try {
        const q = query(
          collection(db, "turnos"),
         where("fecha", "==", formatearFecha(selectedDate))

        );
        const snapshot = await getDocs(q);
      const ocupados = snapshot.docs.map((doc) => ({
  hora: doc.data().hora,
  duracion: doc.data().duracion || 1
}));
setHorariosOcupados(ocupados);

        // Si la hora seleccionada ya está ocupada en este día, limpiarla
      
      } catch (err) {
        console.error("Error al traer turnos:", err);
        setHorariosOcupados([]);
      }
    };
    fetchHorarios();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate]);



  // Sábados: solo horarios hasta las 13:00
  const horariosDisponibles = selectedDate && selectedDate.getDay() === 6
    ? horariosBase.filter((h) => parseInt(h.split(":")[0]) <= 13)
    : horariosBase;



// Convierte los turnos ocupados en horas ocupadas reales
const horasOcupadasPlanas = horariosOcupados.flatMap(t => {
  const index = horariosBase.indexOf(t.hora);
  if (index === -1) return [];

  // Marca todas las horas que ocupa ese turno
  return horariosBase.slice(index, index + (t.duracion || 1));
});

const hayEspacioParaTurno = React.useCallback((horaInicio, duracion) => {
  const indexInicio = horariosBase.indexOf(horaInicio);
  if (indexInicio === -1) return false;

  const indexFin = indexInicio + duracion;

  for (const t of horariosOcupados) {
    const idxOcupado = horariosBase.indexOf(t.hora);
    const idxFinOcupado = idxOcupado + (t.duracion || 1);

    const seSuperpone =
      idxOcupado < indexFin && idxFinOcupado > indexInicio;

    if (seSuperpone) return false;
  }
  return true;
}, [horariosOcupados]);




  // obtiene precio del servicio / opción
  const obtenerPrecioTotal = () => {
    if (!servicio) return 0;
    const servObj = servicios.find(s => s.nombre === servicio);
    if (!servObj) return 0;
    if (!servObj.opciones) return servObj.precio || 0;
    const opt = servObj.opciones.find(o => `${servicio} — ${o.tipo}` === selectedOption);
    return opt ? opt.precio : 0;
  };

  const precioTotal = obtenerPrecioTotal();
  const restante = precioTotal > 0 ? Math.max(0, precioTotal - SENIA) : 0;

  const handleReservar = async (e) => {
    e.preventDefault();

    // validaciones básicas
    if (!nombre || !apellido || !telefono || !servicio || !selectedTime) {
      return alert("Completa todos los campos.");
    }

    // duración y comprobación de índices
    const duracion = duracionServicio;
if (!hayEspacioParaTurno(selectedTime, duracion)) {

  return alert("⛔ Este horario no tiene suficientes horas libres para el servicio seleccionado. Probá otro horario con más espacio disponible.");
}

    const indexHora = horariosBase.indexOf(selectedTime);
    if (indexHora === -1) {
      return alert("Horario inválido. Por favor seleccioná nuevamente.");
    }
    if (indexHora + duracion > horariosBase.length) {
      return alert("La duración del servicio excede el horario disponible. Elegí otro horario.");
    }

    // verificar que ninguna de las horas ya esté ocupada (por seguridad)
    const horasReservadas = horariosBase.slice(indexHora, indexHora + duracion);
  // Verificación REAL de horas ocupadas

    // PRECIO
    const precio = obtenerPrecioTotal();
    if (precio <= 0) {
      // opcional: prevenir reservas sin precio definido
      // return alert("Seleccioná una opción de servicio válida con precio.");
    }

    try {
      // Guardar turnos en Firestore con campos completos
     await addDoc(collection(db, "turnos"), {
  nombre,
  apellido,
  telefono,
  servicio: selectedOption || servicio,
  servicioBase: servicio,
 fecha: formatearFecha(selectedDate),

  hora: selectedTime,   // inicio real
  duracion,             // extensión real
  precio,
  precioTotal: precio,
  senia: SENIA,
  restante: Math.max(0, precio - SENIA),
  timestamp: Timestamp.now(),
  estado: "pendiente",
});


      

      // MENSAJE PARA EL CLIENTE CON DATOS DE PAGO (usamos DATOS_PAGO)
      const mensaje =
`📅 *Reserva pendiente de confirmación*
────────────────────
👤 *${nombre} ${apellido}*
📞 *${telefono}*
💇‍♀️ *Servicio:* ${selectedOption || servicio}
🕒 *Duración:* ${duracion} hora(s)
📆 *Fecha:* ${formatearFecha(selectedDate)}

⏰ *Hora:* ${selectedTime}
────────────────────
💰 *Precio total:* $${precio}
💸 *Seña:* $${SENIA}
📉 *Restante:* $${Math.max(0, precio - SENIA)}
────────────────────

⚠️ *Importante:* El precio final puede variar según el largo y el estado real del cabello al momento del turno.

────────────────────

🏦 *DATOS PARA LA SEÑA*
👤 Titular: *${DATOS_PAGO.titular}*
🏦 Banco: ${DATOS_PAGO.banco}
🔤 Alias: *${DATOS_PAGO.alias}*
🏧 CVU: *${DATOS_PAGO.cvu}*
💵 Enviar: *$${SENIA}*
────────────────────
📌 *Importante*: Enviá el comprobante por este chat para confirmar tu turno.

✨ Muchas gracias por tu reserva. ¡Te esperamos en Shanna! 💖✨`;

      window.open(`https://wa.me/542665041280?text=${encodeURIComponent(mensaje)}`, "_blank");

      // limpiar form y actualizar estados locales
      setNombre("");
      setApellido("");
      setTelefono("");
      setServicio("");
      setSelectedOption("");
      setSelectedTime("");

      // después de guardar, refrescar horarios del día actual (opcional)
      // fetchHorarios se ejecutará por el efecto dependiente de selectedDate, pero lo forzamos:
      const q = query(collection(db, "turnos"), where("fecha", "==", selectedDate.toDateString()));
      const snapshot = await getDocs(q);
      setHorariosOcupados(snapshot.docs.map((doc) => ({
  hora: doc.data().hora,
  duracion: doc.data().duracion || 1
})));

      alert("✅ Turno registrado. Enviá el comprobante por WhatsApp para confirmar.");
    } catch (error) {
      console.error("Error al guardar turno:", error);
      alert("❌ Ocurrió un error al registrar el turno.");
    }
  };

  // helper para cambiar la fecha desde la UI (asegura limpieza de selección)
  const seleccionarFecha = (d) => {
    setSelectedDate(d);
    setSelectedTime("");
    setSelectedOption("");
  };

  return (
    <motion.div
      className="turnos-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      <motion.h2
        className="turnos-title"
        initial={{ y: -20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        Reserva tu turno ✨
      </motion.h2>

      {/* DÍAS DISPONIBLES */}
      <motion.div
        className="dias-lista"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
      >
        {dias.map((d, i) => (
          <motion.div
            key={i}
            className={`dia-item ${selectedDate && selectedDate.toDateString() === d.toDateString() ? "activo" : ""}`}
            onClick={() => seleccionarFecha(d)}
            whileHover={{ scale: 1.07 }}
            whileTap={{ scale: 0.95 }}
          >
            <span>{d.toLocaleDateString("es-AR", { weekday: "short" })}</span>
            <p>{d.getDate()}</p>
          </motion.div>
        ))}
      </motion.div>

      {/* HORARIOS */}
      <AnimatePresence mode="wait">
        <motion.div
          key={selectedDate ? selectedDate.toDateString() : "no-date"}
          className="horarios-container"
          initial={{ opacity: 0, y: 6 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -6 }}
          transition={{ duration: 0.35 }}
        >
          {horariosDisponibles.map((hora) => {
           // Duración del servicio seleccionado
const durActual = obtenerDuracionServicio(servicio, selectedOption, servicios);


// Revisamos si hay espacio antes de seleccionar
const disponible = hayEspacioParaTurno(hora, durActual);


// Hora ocupada por otro turno
const ocupado = horasOcupadasPlanas.includes(hora);

// Bloqueado por extensión de un turno previo
const bloqueado = !ocupado && !disponible;

            const seleccionado = selectedTime === hora;
            return (
              <motion.button
                key={hora}
                className={`hora-btn ${
                  ocupado ? "ocupado" : bloqueado ? "bloqueado" : seleccionado ? "seleccionado" : ""
                }`}
                onClick={() => {
                  if (!ocupado && !bloqueado) setSelectedTime(hora);
                }}
                disabled={ocupado || bloqueado}
                whileHover={!ocupado && !bloqueado && { scale: 1.08 }}
                whileTap={!ocupado && !bloqueado && { scale: 0.9 }}
              >
                {hora}
              </motion.button>
            );
          })}
        </motion.div>
      </AnimatePresence>

      {/* FORMULARIO */}
      <AnimatePresence>
        {selectedTime && (
          <motion.form
            onSubmit={handleReservar}
            className="turnos-form elegante"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
          >
            <h3 className="titulo-form">💖 Confirmá tu turno</h3>

            {/* Resumen del turno */}
            <motion.div
              className="resumen-turno"
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
            >
              <p><strong>📅 Fecha:</strong> {selectedDate ? selectedDate.toLocaleDateString("es-AR") : ""}</p>
              <p><strong>⏰ Hora:</strong> {selectedTime}</p>
              {servicio && <p><strong>💇‍♀️ Servicio:</strong> {servicio}</p>}
            </motion.div>

            {/* Campos */}
            <div className="form-group-doble">
              <div className="form-group">
                <label>Nombre</label>
                <input
                  type="text"
                  value={nombre}
                  onChange={(e) => setNombre(e.target.value)}
                  placeholder="Ej: Sandra"
                  required
                />
              </div>

              <div className="form-group">
                <label>Apellido</label>
                <input
                  type="text"
                  value={apellido}
                  onChange={(e) => setApellido(e.target.value)}
                  placeholder="Ej: Olivares"
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label>Teléfono (WhatsApp)</label>
              <input
                type="tel"
                value={telefono}
                onChange={(e) => setTelefono(e.target.value)}
                placeholder="Ej: +54 9 266..."
                required
              />
            </div>
<div className="aviso-importante">
  <p style={{
    background: "#fff3cd",
    border: "1px solid #ffeeba",
    padding: "10px",
    borderRadius: "8px",
    color: "#856404",
    fontSize: "14px",
    marginBottom: "15px"
  }}>
    <strong>Aviso importante:</strong> Algunos servicios tienen un precio estimado según el largo del cabello.  
    Si el largo o volumen real es diferente al seleccionado, el precio y la duración podrán ajustarse al servicio adecuado.
  </p>
</div>

            {/* Selector de servicios — NUEVO DISEÑO */}
            <div className="form-group">
              <label>Elegí el servicio</label>

              <div className="servicios-grid">
                {servicios.map((s, i) => (
                  <motion.div
                    key={i}
                    className={`servicio-card ${servicio === s.nombre ? "activo" : ""}`}
                    onClick={() => {
                      setServicio(s.nombre);
                      setSelectedOption(""); // reinicia opciones si cambia
                    }}
                    whileHover={{ scale: 1.03 }}
                    whileTap={{ scale: 0.98 }}
                  >
                    <div className="servicio-icon">
                      {s.icon || "💇‍♀️"}
                    </div>

                    <p className="servicio-nombre">{s.nombre}</p>

                    {/* Mostrar precio si NO tiene opciones */}
                    {!s.opciones && (
                      <p className="servicio-precio">${s.precio}</p>
                    )}

                    {/* Mostrar texto si tiene opciones */}
                    {s.opciones && (
                      <p className="servicio-precio-opciones">Variantes disponibles</p>
                    )}
                  </motion.div>
                ))}
              </div>
            </div>

            {servicio && servicios.find(s => s.nombre === servicio)?.opciones && (
              <div className="form-group">
                <label>Elegí una opción</label>

                <div className="opciones-grid">
                  {servicios
                    .find(s => s.nombre === servicio)
                    .opciones.map((opt, i) => {
                      const value = `${servicio} — ${opt.tipo}`;
                      return (
                        <motion.div
                          key={i}
                          className={`opcion-card ${selectedOption === value ? "activo" : ""}`}
                          onClick={() => setSelectedOption(value)}
                          whileHover={{ scale: 1.03 }}
                          whileTap={{ scale: 0.97 }}
                        >
                          <p className="opcion-tipo">{opt.tipo}</p>
                          <p className="opcion-precio">${opt.precio}</p>
                        </motion.div>
                      );
                    })}
                </div>
              </div>
            )}

            {precioTotal > 0 && (
              <motion.div
                className="total-container"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4 }}
              >
                <h4 className="total-titulo">🧾 Resumen del costo</h4>

                <div className="total-linea">
                  <span>Total del servicio:</span>
                  <strong>${precioTotal}</strong>
                </div>

                <div className="total-linea">
                  <span>Seña:</span>
                  <strong>${SENIA}</strong>
                </div>

                <div className="total-linea total-restante">
                  <span>Restante:</span>
                  <strong>${restante}</strong>
                </div>
              </motion.div>
            )}

            {/* Bloque informativo sobre la seña */}
            <motion.div
              className="info-senia"
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
            >
              <h4>💸 Seña requerida</h4>
              <p>
                Para confirmar tu turno, se debe realizar una <strong>seña de ${SENIA}</strong>.  
                Una vez hecha la transferencia, por favor enviá el <strong>comprobante por WhatsApp</strong> al número indicado.  
                El turno quedará confirmado luego de verificar el pago.
              </p>
              <p style={{ marginTop: 8, fontSize: 14 }}>
                Datos de pago: <strong>{DATOS_PAGO.titular}</strong> — Alias: <strong>{DATOS_PAGO.alias}</strong> — CVU: <strong>{DATOS_PAGO.cvu}</strong>
              </p>
            </motion.div>

            <motion.button
              type="submit"
              className="reservar-btn pulse"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Enviar y confirmar por WhatsApp 💬
            </motion.button>
          </motion.form>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

export default Turnos;
